import React, {useState, useEffect} from 'react'
/*import ImageSlider from '../micro/ImageSlider';*/
/*import SimpleImageSlider from "react-simple-image-slider";*/
/*import { useState } from 'react';*/
/*import cover_picture from '../coverPics/01.jpg'*/

import pic001 from "../references/selection/001.jpg"
import pic002 from "../references/selection/002.jpg"
import pic003 from "../references/selection/003.jpg"
import pic004 from "../references/selection/004.jpg"
import pic005 from "../references/selection/005.jpg"
import pic006 from "../references/selection/006.jpg"
import pic007 from "../references/selection/007.jpg"
import pic008 from "../references/selection/008.jpg"
import pic009 from "../references/selection/009.jpg"
import pic010 from "../references/selection/010.jpg"

const images = [pic006,pic002,pic003,pic004,pic005,pic001,pic007,pic008,pic009,pic010];



export default function LandingPage() {
  const [image_index, set_image_index] = useState(0)
  let _index = 0
  

    // change image every 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            _index ++
            if(_index >= images.length){
                _index = 0
            } 
            set_image_index(_index)
        }, 3000)

        return () => clearInterval(interval)
    }, images)
    
    return (
      <div className='landing-page-container'>

      <img src={images[image_index]} alt="pictures" />

        {/* 
        <div className="image-slider-container">
        <SimpleImageSlider
        width="2000px"
        height="500px"
        images={images}
        showBullets={false}
        autoPlay={true}
        showNavs={false}
        loop={true}
        autoPlayDelay={3}
        />
        </div>
        */}
        
      
      <h1>Üdvözlöm az ÁramlásSzimuláció.hu weboldalán!</h1>
    </div>
  );
}
